// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_BtUuS {
  padding: 0px 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  border-radius: 20px 0 0 0px;
  background-color: var(--white-background);


}

.clientsHeader_rXev8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
  padding: 10px 10px 0px;
  width: 95%;
  min-height: 110px;
  box-sizing: border-box;
  .searchContainer_DBsnk {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.clientsTable_W8qo_ {
  width: 83vw;

  overflow-x: auto;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  border: 1px solid var(--eaecf0-border);;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.inputWrapper_ArCZj {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 0 10px 10px 0;
}

.searchInput_bKVAH {
  padding: 10px 10px 10px 35px;
  border: 1px solid  var(--ccc-border);
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  width: 250px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  &::placeholder {
    color: var(--aaa-color);

  }
}

.inputIconInside_u6tpY {
  position: absolute;
  left: 10px; 
  font-size: 16px;
  color: var(--aaa-color);
}
.inputIconOutsideContainer_M5c1D {
  height: 100%;
  display: flex;

  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: var(--_233f39-background);
  position: absolute;
  right: 0px;
  border-radius: 0 10px 10px 0;
  -webkit-border-radius: 0 10px 10px 0;
  -moz-border-radius: 0 10px 10px 0;
  -ms-border-radius: 0 10px 10px 0;
  -o-border-radius: 0 10px 10px 0;
}

.infoBtn_zxiD4 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: var(--_233f39-background);
  color: var(--white-color);
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  -ms-border-radius: 15px;
  -o-border-radius: 15px;
  img {
    width: 15px;
    height: 15px;
  }
}
.addButton_BfTQn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  width: 40px;
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
  img {
    width: 15px;
    height: 15px;
  }
  &:hover {
    background-color: var(--_122521-background);

  }
}

.btnNewClient_HJiYn {
  width: auto;
  min-width: fit-content;
}


.name_jfrTf {
  color: var(--_3-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  > div {
    display: flex;
    flex-direction: column;
  }
}
.table_bltwN {
  text-align: start;
  border-collapse: collapse;
  width: 100%;
  thead {
    background-color: var(--f5-background);
  }
}

.table_bltwN {
  tbody {
    p {
      margin: 0;
    } 
    tr {
      border-top: 1px solid var(--eaecf0-border);
      border-bottom: 1px solid var(--eaecf0-border);
      height: 20px;
    }
  }
  th {
    text-align: start;
    padding: 10px; 
    color: var(--_3-color);
    font-weight: 500; 
    width: 150px; 
    color: var(--_6-color);
  }

  td {
    padding: 10px; 
    color: var(--_6-color);
    font-size: 13px;
    height: 20px;
    p {
      margin: 0;
    }
  }

  thead th {
    min-width: 120px; 
  }

  .small_DaQ9g {
    min-width: 140px;
    width: 40px;
  }
  td p:first-of-type {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
.actions_MoceK {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  img {
    cursor: pointer;
  }
}

.transacciones_FqAHb {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100px;
  a {
    font-weight: bold;
  }
  a,
  span {
    color: var(--_073f31-color);
  }
}



.item_menu_actions_YZmqS {
  list-style-type: none;
  color: var(--white-color);
  cursor: pointer;
}

.transacciones_FqAHb {
  display: flex;
  flex-direction: column;
  gap: 3px;
  a {
    font-weight: bold;
  }
  a,
  span {
    color: var(--_073f31-color);
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

.bg_qveBy { 
  background-color: var(--_FFFFFF80-background) ;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.newClientContainer__kr_T {
  background-color: var(--white-background);

  padding-bottom: 20px;
  height: 80vh;
  width: 80%;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_PzecL 300ms ease-out forwards;
  -webkit-animation: scaleUp_PzecL 300ms ease-out forwards;
  &::-webkit-scrollbar {
    display: none;
  }


  .containerHeader_TkXyv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
    border-bottom: 1px solid var(--eb-border);
    h3 {
      color: var(--_2-color);
    }
    span {
  background-color: var(--ed-background);

      width: 25px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      -ms-border-radius: 5px;
      -o-border-radius: 5px;
      cursor: pointer;
    }
  }
}
.containerNewClientForm_uptWc {
  width: 80%;
  margin: 0 auto;
  padding: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.typeClient_nUEcl {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 300px;
  button {
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    flex: 1 1;
    background-color: transparent;
  }
}

.typeClientActivate_nsR_2 {
  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_9-color);
  }
  .selected_x1u68 {
    background-color: var(--white-background);

    box-shadow: 0px 3px 8px rgb(172, 172, 172);
    box-shadow: 0px 3px 8px var(--ac-shadow);
    color: var(--black-color);
  }
}

.typeClientDisabled_Lnw82 {
  background-color: transparent;
}
.button_WgGb3 {
  cursor: pointer;
  background-color: transparent;
  text-decoration: underline;
  font-weight: 600;
  color: var(--_18181b-color);
  font-size: 14px;
}
.newClientForm_IRpWy {
  label {
    border-bottom: 1px solid var(--_11a3812c-border);
    padding: 10px 0;
    p {
      color: var(--_2-color);
      font-weight: 400;
    }
  }
  .detailsBill_SLrCG {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    button {
      background-color: transparent;
      border: none;
      outline: none;
      text-decoration: underline;
      cursor: pointer;
    }
    .optionsDetailsBill_z3eYm {
      display: flex;
      align-items: center;
      gap: 10px;
      text-align: end;
    }
  }
  .billInfoInputs_og1iK {
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      flex: 1 1;
      gap: 10px;
      box-sizing: border-box;
      .info_cGkNj {
        width: 100%;
      }
    }
  }
  .infoBillContainer_DGWwJ {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .infoBill_HVDe9 {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 5px;
    span {
      color: var(--_71-color);
    }
    .infoBillContainer_DGWwJ {
      width: 100%;
      display: flex;
      align-items: center;
      .info_cGkNj {
        flex-direction: column;
        align-items: start;
      }
    }
    .info_cGkNj {
      display: flex;
      width: 100%;
      span {
        width: fit-content;
        color: var(--_71-color);
      }
    }
    .button_WgGb3 {
      width: fit-content;
      background-color: transparent;
      outline: none;
      border: none;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
    }
  }

  .info1_yWAAf {
    margin-top: 20px;
  }
  .info_cGkNj {
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: space-between;

    span {
      color: var(--_71-color);
      font-weight: bold;
    }
  }
  .billInfoInputs_og1iK .info_cGkNj {
    flex-direction: column;
    align-items: start;
    flex-wrap: wrap;
  }
  .row_ORKx_ {
    display: flex;
    gap: 10px;
    .info_cGkNj {
      flex: 1 1;
    }
  }

  button[disabled],
  input[disabled],
  select[disabled],
  option[disabled],
  textarea[disabled] {
    background-color: transparent;
  }

  button,
  input,
  select,
  option,
  textarea {
    border: none;
    outline: none;
    background-color: var(--f4-background);

    padding: 12px;
    box-sizing: border-box;
  }
  button::placeholder,
  input::placeholder,
  select::placeholder,
  option::placeholder,
  textarea::placeholder {
    color: var(--_75-color);
  }

  input {
    width: 100%;

    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
  }
  input[type="checkbox"] {
    width: fit-content;
  }
  .squareContainer_jKBsR {
    display: flex;

    .square_n1vLg {
      background-color: var(--f4-background);
      border: 1px solid var(--df-border);
      flex: 2 1;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      gap: 10px;
      padding-left: 10px;
      span {
        color: var(--_82-color);
        font-weight: bold;
      }
      p {
        margin: 0;
        color: var(--black-color);
        font-weight: 600;
      }
    }
    .square_n1vLg.arrow_qvZmn {
      align-items: center;
      flex: 1 1;
      padding: 0;
      .icon_rFG9L {
        height: 20px;
        width: 20px;
      }
    }
    .accountNumber_oeqKD {
      flex: 3 1;
    }
  }
  .payMethodContainer_OluFE {
    display: flex;
    gap: 10px;
    flex-direction: column;
    border: 1px solid var(--_11a3812c-border);
    color: var(--_1e0045-color);
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    span {
      font-weight: 600;
    }
  }

  .payInfo_Mo2P7 {
    display: flex;
    gap: 10px;
  }

  .defaultBank_wMO0Q {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 20px;
    gap: 30px;
    div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    p {
      margin: 0;
      color: var(--_2ebc89-color);

    }
    input {
      width: fit-content;
    }
  }
  .delete_FeC5D {
    background-color: var(--dc3545-background);
    height: 20px;
    min-width: 20px;
    max-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;
    .icon_rFG9L {
      height: 13px;
      width: 13px;
    }
  }


  .parametersCounter_RfIOg {
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 5px;
    .icon_rFG9L {
      height: 10px;
      width: 10px;
      -webkit-transition: all 300ms;
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
    }
    .rotated_FMxsw {
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      -o-transform: rotate(180deg);
    }
  }
  .parametersHeader_UlWYV {
    display: flex;
    justify-content: space-between;
    p {
      color: var(--_92959858-color);
      margin: 0;
    }
    .button_WgGb3 {
      background-color: transparent;
      border: none;
      outline: none;
      text-decoration: underline;
    }
  }
  .parameter_g4UzV {
    display: flex;
    gap: 10px;
    border-bottom: 1px solid var(--_11a3812c-border);
    div {
      flex: 1 1;
    }
  }
  .parametersContainer_FEsxk {
    transition: all 300ms;
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    overflow: hidden;
    interpolate-size: allow-keywords;
  }
}
.headerPhoneNumer_qBPK7 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.unknown_bvvXe {
  font-size: 14px;
  font-weight: 400; 
  color: var(--_71-color);
}
.phoneNumber_UYR2B {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
}
.buttonPhoneContainer_yDRcN {
  display: flex;
  align-items: center;
  gap: 10px;
}
.phoneContainerUnknown_CtXlu {
  display: flex;
  width: 100%;
}
.phoneContainer_OVSHH {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: column;
  .phoneRow_bU326 {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .delete_FeC5D {
    background-color: var(--dc3545-background);
    height: 20px;
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;
    .icon_rFG9L {
      height: 13px;
      width: 13px;
    }
  }
}

.searchIconsWrappers_SyDo2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.dropdownContainer_CaGHv {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  font-size: 12px;
  .filterSort_eOGa8 {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    .chevronIcon_m10KJ {
      width: 8px;
      height: 8px;
    }
  }
  .dropdownOptions_qaPBQ {
    position: absolute;
    width: 100%;
    margin-top: 4px;
    background: var(--white-background);
    border-radius: 10px;
    box-shadow: 0px 4px 8px var(--_0000001A-shadow);
    z-index: 1000;
    overflow: hidden;
    .dropdownOption_CkraD {
      padding: 8px 12px;
      font-size: 12px;
      font-weight: 500; 
      color: var(--_9c9d9f-color);
      cursor: pointer;
      transition: background-color 0.2s;
    }
  }
}
.optionsPopupContainer_aZSvK {
  position: absolute;
  z-index: 9999;
  bottom: 0px;
  left: 40px;
}
.edit_aJiOe {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: end;
  opacity: 0;
  padding: 0;
  a {
    color: var(--_073f31-color);

  }
  .dotsOptions_BlMlb {
    cursor: pointer;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.inputWrapperHover_RQifl {
  position: relative;
  height: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inputWrapperHover_RQifl:hover{
  .inputContainer_XOjue {
    opacity: 1;
  }
}

.inputContainer_XOjue {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width:25px;
  border-radius: 999px;
  height:25px;

  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.optionsTd_lgR7Z{
  display: flex;
  flex-direction: row-reverse;
}

.optionsTr_eft5D{
  transition: all 300ms;
}
.optionsTr_eft5D:hover {
  zoom: 1.05;
  box-shadow:
    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),
    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);
}


.optionsTr_eft5D:hover{
  .optionsTd_lgR7Z{
    .edit_aJiOe{
      opacity: 1;
    }
  }
}

.paginationContainer_B1Rld {
  display: flex;
  align-items: center;
  justify-content: center;
}

.paginationButton_n1sIF {
  background-color: var(--_10A37F-background);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  margin: 0 10px;
}

.paginationButton_n1sIF:disabled {
  background-color: var(--c-background);
  cursor: not-allowed;
}

.paginationInfo_goRko {
  font-size: 16px;
  color: var(--_3-color);
}



.sectionTableMore_bW8Xs {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr;
  box-sizing: border-box;
}

.sectionTable_I5LK7 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.sectionModal_snMGf {
  width: 100%;
  display: flex;
  overflow-y: auto;
  height: 100%;
}
.containerNewClientFormScroll_Igpqo {
  height: 88vh;
  overflow-y: auto;
}


.containerView_jTidu {
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.containerInput_PACYm { 
  padding-left: 10px;
  padding-right: 10px;
  label {
    font-size: 1.2rem;
  }
}

.containerMain_H3EiE {
   display: grid;
  grid-template-columns: 3fr 0px;
  transition: grid-template-columns 1.9s ease;
  width: 100%;
  height: 100%;
}


.sectionTableMore_bW8Xs {
  /*background: red;*/
  /* width: 100%;
  height: 100%;
  display: grid; */
  grid-template-columns: 3fr 300px;
  /* box-sizing: border-box; */
}

.popupContainer_ntsIc{
  overflow: hidden;
  transform: translateX(100%);
  opacity: 0;
  transition: transform 1.9s ease, opacity 1.9s ease;


}

.popupContainerVisible_NgKB4  {
  transform: translateX(0);
  opacity: 1;

}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Contacts/Contacts.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;;;AAG3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;;EAEX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;EACrB;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,uBAAuB;;EAEzB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;;EAEb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,2CAA2C;;EAE7C;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE;MACE,SAAS;IACX;IACA;MACE,0CAA0C;MAC1C,6CAA6C;MAC7C,YAAY;IACd;EACF;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ;MACE,SAAS;IACX;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;;;AAIA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;;EAEzC,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;EAClD;IACE,aAAa;EACf;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yCAAyC;IACzC;MACE,sBAAsB;IACxB;IACA;EACF,sCAAsC;;MAElC,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;IACjB;EACF;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,SAAO;IACP,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,yCAAyC;;IAEzC,0CAA0C;IAC1C,wCAAwC;IACxC,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE;IACE,gDAAgD;IAChD,eAAe;IACf;MACE,sBAAsB;MACtB,gBAAgB;IAClB;EACF;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB;MACE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;MACb,0BAA0B;MAC1B,eAAe;IACjB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,eAAe;IACjB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB;MACE,aAAa;MACb,SAAO;MACP,SAAS;MACT,sBAAsB;MACtB;QACE,WAAW;MACb;IACF;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR;MACE,uBAAuB;IACzB;IACA;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB;QACE,sBAAsB;QACtB,kBAAkB;MACpB;IACF;IACA;MACE,aAAa;MACb,WAAW;MACX;QACE,kBAAkB;QAClB,uBAAuB;MACzB;IACF;IACA;MACE,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,YAAY;MACZ,0BAA0B;MAC1B,eAAe;MACf,UAAU;IACZ;EACF;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;;IAE9B;MACE,uBAAuB;MACvB,iBAAiB;IACnB;EACF;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;IACb,SAAS;IACT;MACE,SAAO;IACT;EACF;;EAEA;;;;;IAKE,6BAA6B;EAC/B;;EAEA;;;;;IAKE,YAAY;IACZ,aAAa;IACb,sCAAsC;;IAEtC,aAAa;IACb,sBAAsB;EACxB;EACA;;;;;IAKE,uBAAuB;EACzB;;EAEA;IACE,WAAW;;IAEX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;;IAEb;MACE,sCAAsC;MACtC,kCAAkC;MAClC,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,uBAAuB;MACvB,SAAS;MACT,kBAAkB;MAClB;QACE,uBAAuB;QACvB,iBAAiB;MACnB;MACA;QACE,SAAS;QACT,yBAAyB;QACzB,gBAAgB;MAClB;IACF;IACA;MACE,mBAAmB;MACnB,SAAO;MACP,UAAU;MACV;QACE,YAAY;QACZ,WAAW;MACb;IACF;IACA;MACE,SAAO;IACT;EACF;EACA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,yCAAyC;IACzC,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;IACA;MACE,SAAS;MACT,2BAA2B;;IAE7B;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf;MACE,YAAY;MACZ,WAAW;IACb;EACF;;;EAGA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,YAAY;MACZ,WAAW;MACX,6BAA6B;MAC7B,uBAAuB;MACvB,+BAA+B;MAC/B,4BAA4B;MAC5B,2BAA2B;MAC3B,0BAA0B;IAC5B;IACA;MACE,yBAAyB;MACzB,iCAAiC;MACjC,8BAA8B;MAC9B,6BAA6B;MAC7B,4BAA4B;IAC9B;EACF;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B;MACE,6BAA6B;MAC7B,SAAS;IACX;IACA;MACE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;MACb,0BAA0B;IAC5B;EACF;EACA;IACE,aAAa;IACb,SAAS;IACT,gDAAgD;IAChD;MACE,SAAO;IACT;EACF;EACA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;EAClC;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf;MACE,UAAU;MACV,WAAW;IACb;EACF;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,gBAAgB;IAChB;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,2BAA2B;MAC3B,eAAe;MACf,iCAAiC;IACnC;EACF;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV;IACE,2BAA2B;;EAE7B;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,WAAW;;EAEX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV;;yFAEuF;AACzF;;;AAGA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;IACE,iBAAiB;EACnB;AACF;;AAEA;GACG,aAAa;EACd,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB;;kBAEgB;EAChB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,kDAAkD;;;AAGpD;;AAEA;EACE,wBAAwB;EACxB,UAAU;;AAEZ","sourcesContent":[".container {\n  padding: 0px 10px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n  border-radius: 20px 0 0 0px;\n  background-color: var(--white-background);\n\n\n}\n\n.clientsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n  padding: 10px 10px 0px;\n  width: 95%;\n  min-height: 110px;\n  box-sizing: border-box;\n  .searchContainer {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n}\n\n.clientsTable {\n  width: 83vw;\n\n  overflow-x: auto;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  border: 1px solid var(--eaecf0-border);;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border-radius: 0 10px 10px 0;\n}\n\n.searchInput {\n  padding: 10px 10px 10px 35px;\n  border: 1px solid  var(--ccc-border);\n  border-radius: 10px;\n  font-size: 16px;\n  outline: none;\n  width: 250px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  &::placeholder {\n    color: var(--aaa-color);\n\n  }\n}\n\n.inputIconInside {\n  position: absolute;\n  left: 10px; \n  font-size: 16px;\n  color: var(--aaa-color);\n}\n.inputIconOutsideContainer {\n  height: 100%;\n  display: flex;\n\n  align-items: center;\n  justify-content: center;\n  padding: 10px 15px;\n  box-sizing: border-box;\n  background-color: var(--_233f39-background);\n  position: absolute;\n  right: 0px;\n  border-radius: 0 10px 10px 0;\n  -webkit-border-radius: 0 10px 10px 0;\n  -moz-border-radius: 0 10px 10px 0;\n  -ms-border-radius: 0 10px 10px 0;\n  -o-border-radius: 0 10px 10px 0;\n}\n\n.infoBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background-color: var(--_233f39-background);\n  color: var(--white-color);\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 15px;\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  -ms-border-radius: 15px;\n  -o-border-radius: 15px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n}\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  width: 40px;\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n  &:hover {\n    background-color: var(--_122521-background);\n\n  }\n}\n\n.btnNewClient {\n  width: auto;\n  min-width: fit-content;\n}\n\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  img {\n    width: 30px;\n    height: 30px;\n    object-fit: cover;\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n  }\n}\n.table {\n  text-align: start;\n  border-collapse: collapse;\n  width: 100%;\n  thead {\n    background-color: var(--f5-background);\n  }\n}\n\n.table {\n  tbody {\n    p {\n      margin: 0;\n    } \n    tr {\n      border-top: 1px solid var(--eaecf0-border);\n      border-bottom: 1px solid var(--eaecf0-border);\n      height: 20px;\n    }\n  }\n  th {\n    text-align: start;\n    padding: 10px; \n    color: var(--_3-color);\n    font-weight: 500; \n    width: 150px; \n    color: var(--_6-color);\n  }\n\n  td {\n    padding: 10px; \n    color: var(--_6-color);\n    font-size: 13px;\n    height: 20px;\n    p {\n      margin: 0;\n    }\n  }\n\n  thead th {\n    min-width: 120px; \n  }\n\n  .small {\n    min-width: 140px;\n    width: 40px;\n  }\n  td p:first-of-type {\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n.actions {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  img {\n    cursor: pointer;\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100px;\n  a {\n    font-weight: bold;\n  }\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\n\n\n.item_menu_actions {\n  list-style-type: none;\n  color: var(--white-color);\n  cursor: pointer;\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  a {\n    font-weight: bold;\n  }\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n}\n\n.bg { \n  background-color: var(--_FFFFFF80-background) ;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.newClientContainer {\n  background-color: var(--white-background);\n\n  padding-bottom: 20px;\n  height: 80vh;\n  width: 80%;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n\n  .containerHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 30px;\n    border-bottom: 1px solid var(--eb-border);\n    h3 {\n      color: var(--_2-color);\n    }\n    span {\n  background-color: var(--ed-background);\n\n      width: 25px;\n      height: 25px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 5px;\n      -webkit-border-radius: 5px;\n      -moz-border-radius: 5px;\n      -ms-border-radius: 5px;\n      -o-border-radius: 5px;\n      cursor: pointer;\n    }\n  }\n}\n.containerNewClientForm {\n  width: 80%;\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n}\n.typeClient {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 300px;\n  button {\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    flex: 1;\n    background-color: transparent;\n  }\n}\n\n.typeClientActivate {\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_9-color);\n  }\n  .selected {\n    background-color: var(--white-background);\n\n    box-shadow: 0px 3px 8px rgb(172, 172, 172);\n    box-shadow: 0px 3px 8px var(--ac-shadow);\n    color: var(--black-color);\n  }\n}\n\n.typeClientDisabled {\n  background-color: transparent;\n}\n.button {\n  cursor: pointer;\n  background-color: transparent;\n  text-decoration: underline;\n  font-weight: 600;\n  color: var(--_18181b-color);\n  font-size: 14px;\n}\n.newClientForm {\n  label {\n    border-bottom: 1px solid var(--_11a3812c-border);\n    padding: 10px 0;\n    p {\n      color: var(--_2-color);\n      font-weight: 400;\n    }\n  }\n  .detailsBill {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    button {\n      background-color: transparent;\n      border: none;\n      outline: none;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n    .optionsDetailsBill {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      text-align: end;\n    }\n  }\n  .billInfoInputs {\n    display: flex;\n    flex-direction: column;\n    > div {\n      display: flex;\n      flex: 1;\n      gap: 10px;\n      box-sizing: border-box;\n      .info {\n        width: 100%;\n      }\n    }\n  }\n  .infoBillContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .infoBill {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 5px;\n    span {\n      color: var(--_71-color);\n    }\n    .infoBillContainer {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      .info {\n        flex-direction: column;\n        align-items: start;\n      }\n    }\n    .info {\n      display: flex;\n      width: 100%;\n      span {\n        width: fit-content;\n        color: var(--_71-color);\n      }\n    }\n    .button {\n      width: fit-content;\n      background-color: transparent;\n      outline: none;\n      border: none;\n      text-decoration: underline;\n      cursor: pointer;\n      padding: 0;\n    }\n  }\n\n  .info1 {\n    margin-top: 20px;\n  }\n  .info {\n    display: flex;\n    margin-top: 20px;\n    align-items: center;\n    justify-content: space-between;\n\n    span {\n      color: var(--_71-color);\n      font-weight: bold;\n    }\n  }\n  .billInfoInputs .info {\n    flex-direction: column;\n    align-items: start;\n    flex-wrap: wrap;\n  }\n  .row {\n    display: flex;\n    gap: 10px;\n    .info {\n      flex: 1;\n    }\n  }\n\n  button[disabled],\n  input[disabled],\n  select[disabled],\n  option[disabled],\n  textarea[disabled] {\n    background-color: transparent;\n  }\n\n  button,\n  input,\n  select,\n  option,\n  textarea {\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n\n    padding: 12px;\n    box-sizing: border-box;\n  }\n  button::placeholder,\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  textarea::placeholder {\n    color: var(--_75-color);\n  }\n\n  input {\n    width: 100%;\n\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n  }\n  input[type=\"checkbox\"] {\n    width: fit-content;\n  }\n  .squareContainer {\n    display: flex;\n\n    .square {\n      background-color: var(--f4-background);\n      border: 1px solid var(--df-border);\n      flex: 2;\n      display: flex;\n      flex-direction: column;\n      align-items: start;\n      justify-content: center;\n      gap: 10px;\n      padding-left: 10px;\n      span {\n        color: var(--_82-color);\n        font-weight: bold;\n      }\n      p {\n        margin: 0;\n        color: var(--black-color);\n        font-weight: 600;\n      }\n    }\n    .square.arrow {\n      align-items: center;\n      flex: 1;\n      padding: 0;\n      .icon {\n        height: 20px;\n        width: 20px;\n      }\n    }\n    .accountNumber {\n      flex: 3;\n    }\n  }\n  .payMethodContainer {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    border: 1px solid var(--_11a3812c-border);\n    color: var(--_1e0045-color);\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    span {\n      font-weight: 600;\n    }\n  }\n\n  .payInfo {\n    display: flex;\n    gap: 10px;\n  }\n\n  .defaultBank {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    padding: 20px;\n    gap: 30px;\n    div {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    p {\n      margin: 0;\n      color: var(--_2ebc89-color);\n\n    }\n    input {\n      width: fit-content;\n    }\n  }\n  .delete {\n    background-color: var(--dc3545-background);\n    height: 20px;\n    min-width: 20px;\n    max-width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n    .icon {\n      height: 13px;\n      width: 13px;\n    }\n  }\n\n\n  .parametersCounter {\n    margin: 10px 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    .icon {\n      height: 10px;\n      width: 10px;\n      -webkit-transition: all 300ms;\n      transform: rotate(0deg);\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n    }\n    .rotated {\n      transform: rotate(180deg);\n      -webkit-transform: rotate(180deg);\n      -moz-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n      -o-transform: rotate(180deg);\n    }\n  }\n  .parametersHeader {\n    display: flex;\n    justify-content: space-between;\n    p {\n      color: var(--_92959858-color);\n      margin: 0;\n    }\n    .button {\n      background-color: transparent;\n      border: none;\n      outline: none;\n      text-decoration: underline;\n    }\n  }\n  .parameter {\n    display: flex;\n    gap: 10px;\n    border-bottom: 1px solid var(--_11a3812c-border);\n    div {\n      flex: 1;\n    }\n  }\n  .parametersContainer {\n    transition: all 300ms;\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -ms-transition: all 300ms;\n    -o-transition: all 300ms;\n    overflow: hidden;\n    interpolate-size: allow-keywords;\n  }\n}\n.headerPhoneNumer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.unknown {\n  font-size: 14px;\n  font-weight: 400; \n  color: var(--_71-color);\n}\n.phoneNumber {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 10px;\n}\n.buttonPhoneContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.phoneContainerUnknown {\n  display: flex;\n  width: 100%;\n}\n.phoneContainer {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-direction: column;\n  .phoneRow {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  .delete {\n    background-color: var(--dc3545-background);\n    height: 20px;\n    min-width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n    .icon {\n      height: 13px;\n      width: 13px;\n    }\n  }\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.dropdownContainer {\n  position: relative;\n  display: inline-block;\n  margin-left: 10px;\n  font-size: 12px;\n  .filterSort {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    .chevronIcon {\n      width: 8px;\n      height: 8px;\n    }\n  }\n  .dropdownOptions {\n    position: absolute;\n    width: 100%;\n    margin-top: 4px;\n    background: var(--white-background);\n    border-radius: 10px;\n    box-shadow: 0px 4px 8px var(--_0000001A-shadow);\n    z-index: 1000;\n    overflow: hidden;\n    .dropdownOption {\n      padding: 8px 12px;\n      font-size: 12px;\n      font-weight: 500; \n      color: var(--_9c9d9f-color);\n      cursor: pointer;\n      transition: background-color 0.2s;\n    }\n  }\n}\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: 0px;\n  left: 40px;\n}\n.edit {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  opacity: 0;\n  padding: 0;\n  a {\n    color: var(--_073f31-color);\n\n  }\n  .dotsOptions {\n    cursor: pointer;\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    img {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n.inputWrapperHover {\n  position: relative;\n  height: 28px;\n  min-width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputWrapperHover:hover{\n  .inputContainer {\n    opacity: 1;\n  }\n}\n\n.inputContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width:25px;\n  border-radius: 999px;\n  height:25px;\n\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n.optionsTd{\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.optionsTr{\n  transition: all 300ms;\n}\n.optionsTr:hover {\n  zoom: 1.05;\n  box-shadow:\n    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),\n    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);\n}\n\n\n.optionsTr:hover{\n  .optionsTd{\n    .edit{\n      opacity: 1;\n    }\n  }\n}\n\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.paginationButton {\n  background-color: var(--_10A37F-background);\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 5px;\n  margin: 0 10px;\n}\n\n.paginationButton:disabled {\n  background-color: var(--c-background);\n  cursor: not-allowed;\n}\n\n.paginationInfo {\n  font-size: 16px;\n  color: var(--_3-color);\n}\n\n\n\n.sectionTableMore {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  box-sizing: border-box;\n}\n\n.sectionTable {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n.sectionModal {\n  width: 100%;\n  display: flex;\n  overflow-y: auto;\n  height: 100%;\n}\n.containerNewClientFormScroll {\n  height: 88vh;\n  overflow-y: auto;\n}\n\n\n.containerView {\n  overflow-y: auto;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.containerInput { \n  padding-left: 10px;\n  padding-right: 10px;\n  label {\n    font-size: 1.2rem;\n  }\n}\n\n.containerMain {\n   display: grid;\n  grid-template-columns: 3fr 0px;\n  transition: grid-template-columns 1.9s ease;\n  width: 100%;\n  height: 100%;\n}\n\n\n.sectionTableMore {\n  /*background: red;*/\n  /* width: 100%;\n  height: 100%;\n  display: grid; */\n  grid-template-columns: 3fr 300px;\n  /* box-sizing: border-box; */\n}\n\n.popupContainer{\n  overflow: hidden;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: transform 1.9s ease, opacity 1.9s ease;\n\n\n}\n\n.popupContainerVisible  {\n  transform: translateX(0);\n  opacity: 1;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_BtUuS`,
	"clientsHeader": `clientsHeader_rXev8`,
	"searchContainer": `searchContainer_DBsnk`,
	"clientsTable": `clientsTable_W8qo_`,
	"inputWrapper": `inputWrapper_ArCZj`,
	"searchInput": `searchInput_bKVAH`,
	"inputIconInside": `inputIconInside_u6tpY`,
	"inputIconOutsideContainer": `inputIconOutsideContainer_M5c1D`,
	"infoBtn": `infoBtn_zxiD4`,
	"addButton": `addButton_BfTQn`,
	"btnNewClient": `btnNewClient_HJiYn`,
	"name": `name_jfrTf`,
	"table": `table_bltwN`,
	"small": `small_DaQ9g`,
	"actions": `actions_MoceK`,
	"transacciones": `transacciones_FqAHb`,
	"item_menu_actions": `item_menu_actions_YZmqS`,
	"bg": `bg_qveBy`,
	"newClientContainer": `newClientContainer__kr_T`,
	"scaleUp": `scaleUp_PzecL`,
	"containerHeader": `containerHeader_TkXyv`,
	"containerNewClientForm": `containerNewClientForm_uptWc`,
	"typeClient": `typeClient_nUEcl`,
	"typeClientActivate": `typeClientActivate_nsR_2`,
	"selected": `selected_x1u68`,
	"typeClientDisabled": `typeClientDisabled_Lnw82`,
	"button": `button_WgGb3`,
	"newClientForm": `newClientForm_IRpWy`,
	"detailsBill": `detailsBill_SLrCG`,
	"optionsDetailsBill": `optionsDetailsBill_z3eYm`,
	"billInfoInputs": `billInfoInputs_og1iK`,
	"info": `info_cGkNj`,
	"infoBillContainer": `infoBillContainer_DGWwJ`,
	"infoBill": `infoBill_HVDe9`,
	"info1": `info1_yWAAf`,
	"row": `row_ORKx_`,
	"squareContainer": `squareContainer_jKBsR`,
	"square": `square_n1vLg`,
	"arrow": `arrow_qvZmn`,
	"icon": `icon_rFG9L`,
	"accountNumber": `accountNumber_oeqKD`,
	"payMethodContainer": `payMethodContainer_OluFE`,
	"payInfo": `payInfo_Mo2P7`,
	"defaultBank": `defaultBank_wMO0Q`,
	"delete": `delete_FeC5D`,
	"parametersCounter": `parametersCounter_RfIOg`,
	"rotated": `rotated_FMxsw`,
	"parametersHeader": `parametersHeader_UlWYV`,
	"parameter": `parameter_g4UzV`,
	"parametersContainer": `parametersContainer_FEsxk`,
	"headerPhoneNumer": `headerPhoneNumer_qBPK7`,
	"unknown": `unknown_bvvXe`,
	"phoneNumber": `phoneNumber_UYR2B`,
	"buttonPhoneContainer": `buttonPhoneContainer_yDRcN`,
	"phoneContainerUnknown": `phoneContainerUnknown_CtXlu`,
	"phoneContainer": `phoneContainer_OVSHH`,
	"phoneRow": `phoneRow_bU326`,
	"searchIconsWrappers": `searchIconsWrappers_SyDo2`,
	"dropdownContainer": `dropdownContainer_CaGHv`,
	"filterSort": `filterSort_eOGa8`,
	"chevronIcon": `chevronIcon_m10KJ`,
	"dropdownOptions": `dropdownOptions_qaPBQ`,
	"dropdownOption": `dropdownOption_CkraD`,
	"optionsPopupContainer": `optionsPopupContainer_aZSvK`,
	"edit": `edit_aJiOe`,
	"dotsOptions": `dotsOptions_BlMlb`,
	"inputWrapperHover": `inputWrapperHover_RQifl`,
	"inputContainer": `inputContainer_XOjue`,
	"optionsTd": `optionsTd_lgR7Z`,
	"optionsTr": `optionsTr_eft5D`,
	"paginationContainer": `paginationContainer_B1Rld`,
	"paginationButton": `paginationButton_n1sIF`,
	"paginationInfo": `paginationInfo_goRko`,
	"sectionTableMore": `sectionTableMore_bW8Xs`,
	"sectionTable": `sectionTable_I5LK7`,
	"sectionModal": `sectionModal_snMGf`,
	"containerNewClientFormScroll": `containerNewClientFormScroll_Igpqo`,
	"containerView": `containerView_jTidu`,
	"containerInput": `containerInput_PACYm`,
	"containerMain": `containerMain_H3EiE`,
	"popupContainer": `popupContainer_ntsIc`,
	"popupContainerVisible": `popupContainerVisible_NgKB4`
};
export default ___CSS_LOADER_EXPORT___;
